import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { onMounted, onUnmounted, ref } from "vue"

//region Props and Emits

const pageContainerClass = "q-page-container"
const windowHeightClass = "window-height"


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxFormSubmit',
  props: {
  overlay: {
    type: Boolean,
    default: false,
  },

  panel: {
    type: Boolean,
    default: false,
  },

  targetClass: {
    type: String,
  },
},
  emits: ["submit", "discard"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

//region Variables

const divContainer = ref<HTMLDivElement | undefined>()
const isIntersecting = ref(false)

const internalScrollContainerClass = props.overlay ? "q-scrollarea__container" : "overflow-auto"
const observer = new IntersectionObserver((entries) => {
  const div = entries[0]
  isIntersecting.value = div.isIntersecting
})

//endregion

//region Lifecycle

onMounted(() => {
  if (divContainer.value) observer.observe(divContainer.value)
})

onUnmounted(() => {
  observer.disconnect()
})

//endregion

//region Functions

function stopParentSearch(currentParent: HTMLElement | null) {
  if (currentParent === null) return false

  if (props.targetClass) {
    return !currentParent.classList.contains(props.targetClass)
  } else {
    return (
      !currentParent.classList.contains(internalScrollContainerClass) &&
      !currentParent.classList.contains(pageContainerClass) &&
      !currentParent?.parentElement?.classList.contains(windowHeightClass)
    )
  }
}

function isInnerScroll(currentParent: HTMLElement) {
  if (props.targetClass) {
    return currentParent.classList.contains(props.targetClass)
  } else {
    return (
      currentParent.classList.contains(internalScrollContainerClass) ||
      currentParent.parentElement?.classList.contains(windowHeightClass)
    )
  }
}

function scrollToBottom() {
  const el = divContainer.value
  if (!el) return

  let currentParent: HTMLElement | null = el.parentElement

  // There is a parent, and it doesn't contain either of the above classes
  while (stopParentSearch(currentParent)) {
    currentParent = currentParent?.parentElement || null
  }

  if (currentParent === null) return

  // If it is internal, use the current selected parent, else the whole page window.
  if (isInnerScroll(currentParent)) {
    currentParent.scrollTo({ top: currentParent.scrollHeight, behavior: "smooth" })
  } else {
    window.scrollTo({ top: currentParent.scrollHeight, behavior: "smooth" })
  }
}

function discard() {
  emit("discard")
}

function submit() {
  emit("submit")
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_page_sticky = _resolveComponent("q-page-sticky")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _mergeProps({
      ref_key: "divContainer",
      ref: divContainer
    }, _ctx.$attrs, { class: "flex justify-evenly" }), [
      _createVNode(SfxBtnOutline, {
        onClick: discard,
        class: "col q-mr-sm"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("sfxButtons.btn_discard_changes")), 1)
        ]),
        _: 1
      }),
      _createVNode(SfxBtn, {
        onClick: submit,
        class: "col q-ml-sm"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("sfxButtons.btn_submit_changes")), 1)
        ]),
        _: 1
      })
    ], 16),
    (!isIntersecting.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (props.overlay)
            ? (_openBlock(), _createBlock(SfxBtnOutline, {
                key: 0,
                size: "lg",
                class: "sfx-btn--scroll sfx-btn--scroll-overlay fixed-bottom q-mb-lg",
                icon: _unref(Icons).ARROW_DOWN,
                onClick: scrollToBottom,
                dense: ""
              }, null, 8, ["icon"]))
            : (props.panel)
              ? (_openBlock(), _createBlock(SfxBtnOutline, {
                  key: 1,
                  size: "lg",
                  class: "sfx-btn--scroll sfx-btn--scroll-panel",
                  icon: _unref(Icons).ARROW_DOWN,
                  onClick: scrollToBottom,
                  dense: ""
                }, null, 8, ["icon"]))
              : (_openBlock(), _createBlock(_component_q_page_sticky, {
                  key: 2,
                  position: "bottom",
                  offset: [20, 20]
                }, {
                  default: _withCtx(() => [
                    _createVNode(SfxBtnOutline, {
                      size: "lg",
                      class: "sfx-btn--scroll",
                      icon: _unref(Icons).ARROW_DOWN,
                      onClick: scrollToBottom,
                      dense: ""
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }))
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

})